import { useSimpleReducer } from "@common/hooks";
import React, { PropsWithChildren, createContext } from "react";
import { searchOrder } from "../Search/const";

type SearchContextFields = {
  closeSearch: () => void;
  closeDrawer: () => void;
  searchType: SearchType;
};

export type SearchContextType = SearchContextFields & {
  dispatch: (
    changes: Partial<SearchContextFields> & { dispatch?: never }
  ) => void;
};

const defaultValues: SearchContextType = {
  closeSearch: () => {},
  closeDrawer: () => {},
  searchType: searchOrder[0],
  dispatch: () => {},
};

export const SearchContext = createContext<SearchContextType>(defaultValues);

export const SearchProvider = (
  props: PropsWithChildren<Partial<SearchContextFields>>
) => {
  const [state, dispatch] = useSimpleReducer<SearchContextType>({
    ...defaultValues,
    ...props,
  });
  return (
    <SearchContext.Provider value={{ ...state, dispatch }}>
      {props.children}
    </SearchContext.Provider>
  );
};
